// src/components/SlotCountWatcher.jsx
import { useEffect } from "react";
import { supabase } from "../utils/supabaseClient";

export default function SlotCountWatcher({ businessId, flyerId, setSlotCount }) {
  useEffect(() => {
    if (!flyerId) {
      setSlotCount(0);
      return;
    }

    const fetchSlotCount = async () => {
      const { count, error } = await supabase
        .from("flyer_slots")
        .select("id", { count: "exact", head: true })
        .eq("flyer_id", flyerId);   // ✅ ONLY filter needed

      if (error) {
        console.error("Slot count error:", error);
        return;
      }

      setSlotCount(count || 0);
    };

    fetchSlotCount();
  }, [businessId, flyerId, setSlotCount]);

  return null;
}
